module.exports = __webpack_public_path__ + "img/xuanniao_banner.e5c64aa6.png";